// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-workbook-navigation-minimal {
  width: 416px;
  height: 540px;
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 70vh;
  max-width: 80vw;
}
.dl-core-workbook-navigation-minimal__row {
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 100%;
}
.dl-core-workbook-navigation-minimal__row_inactive {
  opacity: 0.5;
  cursor: initial;
}
.dl-core-workbook-navigation-minimal__info {
  padding-right: 0;
  display: flex;
  width: 100%;
  overflow: hidden;
}
.dl-core-workbook-navigation-minimal__popup {
  border-radius: 4px;
  overflow: hidden;
  background-color: var(--g-color-base-float);
}
.dl-core-workbook-navigation-minimal__icon {
  margin-right: 12px;
  position: relative;
  bottom: 2px;
  flex: 0 0 auto;
  display: flex;
}
.dl-core-workbook-navigation-minimal__name {
  flex: 3 1 30%;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 100px;
  color: var(--g-color-text-primary);
}
.dl-core-workbook-navigation-minimal__name span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-core-workbook-navigation-minimal__name-line {
  display: flex;
  overflow: hidden;
}
.dl-core-workbook-navigation-minimal__date {
  flex: 0 0 60px;
  min-width: auto;
}
.dl-core-workbook-navigation-minimal__loader {
  margin: auto;
}
.dl-core-workbook-navigation-minimal__empty-entries {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dl-core-workbook-navigation-minimal__control {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 20px;
}
.dl-core-workbook-navigation-minimal__sort-control {
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.dl-core-workbook-navigation-minimal__sort-select {
  min-width: 140px;
}
.dl-core-workbook-navigation-minimal__items {
  display: flex;
  gap: var(--g-spacing-4);
  flex-direction: column;
  overflow-y: auto;
}
.dl-core-workbook-navigation-minimal__items-box {
  display: flex;
  flex-direction: column;
  gap: var(--g-spacing-1);
}
.dl-core-workbook-navigation-minimal__list-title {
  margin-left: var(--g-spacing-4);
}
.dl-core-workbook-navigation-minimal__shared-item-icon {
  margin-left: var(--g-spacing-2);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/WorkbookNavigationMinimal/WorkbookNavigationMinimal.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAGI;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AADR;AAII;EACI,YAAA;EACA,eAAA;AAFR;AAKI;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAHR;AAMI;EACI,kBAAA;EACA,gBAAA;EACA,2CAAA;AAJR;AAOI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AALR;AAQI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AANR;AAQQ;EClDJ,mBAAA;EACA,gBAAA;EACA,uBAH4B;ADgDhC;AAQI;EACI,aAAA;EACA,gBAAA;AANR;AASI;EACI,cAAA;EACA,eAAA;AAPR;AAUI;EACI,YAAA;AARR;AAWI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AATR;AAYI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;AAVR;AAaI;EACI,2BAAA;EAAA,sBAAA;AAXR;AAcI;EACI,gBAAA;AAZR;AAeI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAbR;AAgBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAdR;AAiBI;EACI,+BAAA;AAfR;AAkBI;EACI,+BAAA;AAhBR","sourcesContent":[".dl-core-workbook-navigation-minimal {\n  width: 416px;\n  height: 540px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-height: 70vh;\n  max-width: 80vw;\n}\n.dl-core-workbook-navigation-minimal__row {\n  cursor: pointer;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  width: 100%;\n}\n.dl-core-workbook-navigation-minimal__row_inactive {\n  opacity: 0.5;\n  cursor: initial;\n}\n.dl-core-workbook-navigation-minimal__info {\n  padding-right: 0;\n  display: flex;\n  width: 100%;\n  overflow: hidden;\n}\n.dl-core-workbook-navigation-minimal__popup {\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: var(--g-color-base-float);\n}\n.dl-core-workbook-navigation-minimal__icon {\n  margin-right: 12px;\n  position: relative;\n  bottom: 2px;\n  flex: 0 0 auto;\n  display: flex;\n}\n.dl-core-workbook-navigation-minimal__name {\n  flex: 3 1 30%;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  min-width: 100px;\n  color: var(--g-color-text-primary);\n}\n.dl-core-workbook-navigation-minimal__name span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-core-workbook-navigation-minimal__name-line {\n  display: flex;\n  overflow: hidden;\n}\n.dl-core-workbook-navigation-minimal__date {\n  flex: 0 0 60px;\n  min-width: auto;\n}\n.dl-core-workbook-navigation-minimal__loader {\n  margin: auto;\n}\n.dl-core-workbook-navigation-minimal__empty-entries {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n.dl-core-workbook-navigation-minimal__control {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 20px;\n}\n.dl-core-workbook-navigation-minimal__sort-control {\n  min-width: fit-content;\n}\n.dl-core-workbook-navigation-minimal__sort-select {\n  min-width: 140px;\n}\n.dl-core-workbook-navigation-minimal__items {\n  display: flex;\n  gap: var(--g-spacing-4);\n  flex-direction: column;\n  overflow-y: auto;\n}\n.dl-core-workbook-navigation-minimal__items-box {\n  display: flex;\n  flex-direction: column;\n  gap: var(--g-spacing-1);\n}\n.dl-core-workbook-navigation-minimal__list-title {\n  margin-left: var(--g-spacing-4);\n}\n.dl-core-workbook-navigation-minimal__shared-item-icon {\n  margin-left: var(--g-spacing-2);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
